import "./membre.scss";
import "../../assets/scripts/isotope_init.js";
import $ from 'jquery';

//Ajoute la class current-menu-item au Menu à propos quand on se trouve dans un single-membre
if($('body').hasClass('single-membre')){
    //('Page membre!');
    var  menuProposString = $('#main-menu li.menu-item')[1];
    var  menuMembreString = $('#main-menu li.menu-item')[5];
    //console.log(menuMembreString);
    $('.menu').find(menuProposString).toggleClass('current-menu-item').addClass('current-menu-ancestor');
    $('.menu').find(menuMembreString).toggleClass('current-menu-item');
}



// ISOTOPE
var $grid_membre = $('.grid_membre');
var itemSelector = '.un-membre';
if($grid_membre.length != 0) {
    $grid_membre.isotope({
        itemSelector: itemSelector,
        layoutMode: 'fitRows',
    });

    // FILTRE
    // Type
    var leType = 'default';
    $('select[name="type"]').change(function(){
        leType = $(this).val();
        if (leType == 'default'){
            $grid_membre.isotope({ filter: '*' });
        } else {
            $grid_membre.isotope({ filter: '.type_membre-'+leType });
        }
    });
}